/**
 *
 * Criação do objecto de edição de chamada.
 * Esta função irá preparar o objecto a ser enviado para API, onde só os campos
 * editados na página é que serão enviados.
 *
 * @param {Object}  data
 *
*/
const create = data => {
    const call = {
        id: data.id,
        ...( data.internalObservations && { observations: data.internalObservations })
    };

    return call;
};
const requiredFields = [ { field: 'stateId', isRequiredOnEdit: false } ];
export {
    create,
    requiredFields
};